import { useTranslation } from 'react-i18next'
import cn from 'classnames/bind'

import styles from './CommonLimitOrg.module.scss';


const cx = cn.bind(styles)

type Props = {
  currency: string
  personalLimit: string | null
  commonLimit: string | null
}

export const CommonLimitOrg = ({
  currency,
  personalLimit,
  commonLimit,
}: Props) => {
  const { t } = useTranslation('cafeteria')

  const limitNone = !personalLimit
  const limitActive = !limitNone

  return (
    <>
      <div className={cx(styles.limitTitle, { limitDisabled: limitActive })}>
        {`${t('settings_limit_common_label', 'Общий лимит')}:\u00A0`}
        <span className={cx({ limitActive, limitNone, limitDisabled: limitActive })}>
          {commonLimit !== null
            ? `${commonLimit} ${t('settings_limit_units', { currency })}`
            : t('settings_limit_absent', 'Отсутствует')}
        </span>
      </div>
      <div className={cx(styles.limitDescription, { limitDisabled: limitActive })}>
        <div>{t('settings_limit_by_org_comment_line1', 'Лимит расходов, устанавливаемый')}</div>
        <div>{t('settings_limit_by_org_comment_line2', 'образовательным учреждением')}</div>
      </div>
    </>
  )
}
